import React, { useRef } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Col, Dropdown, Input, Menu, Pagination, Row, Spin, Badge } from 'antd';
import { Slider as SliderAntd } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import categoryProductAPI from '~/api/CategoryProductAPI';
import productAPI from '~/api/ProductAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import ItemProduct from '~/components/ItemProduct';
import { getNumberWithCommas } from '~/utils';
import styles from './Products.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { FreeMode } from 'swiper';
import Slider from 'react-slick';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import BannerHome from '../Home/components/BannerHome';
import homeAPI from '~/api/HomeAPI';
import { useSelector } from 'react-redux';
import { cartItemsCountSelector } from '~/pages/Cart/selector';

const { Search } = Input;

const cx = classNames.bind(styles);

const defaultImages = [
    {
        image: IMAGES.ImageBanner01,
    },
    {
        image: IMAGES.ImageBanner02,
    },
    {
        image: IMAGES.ImageBanner03,
    },
];

const SearchComponent = styled.div`
    width: 100%;
    .ant-input-search-with-button .ant-input-group .ant-input {
        height: 44px;
        background-color: #fff7fd;
    }
    .ant-input-search-button {
        height: 44px;
    }
    .ant-btn-primary {
        background: #311d4f;
    }
    @media screen and (max-width: 480px) {
        margin: 20px 10px;
        /* .ant-input-search .ant-input-group .ant-input-group-addon:last-child {
            left: -215px;
        } */
        .ant-input-search-with-button .ant-input-group .ant-input {
            height: 44px;
            background-color: #f6f6f6;
        }
        .ant-btn-primary {
            background: #f6f6f6;
            border-left: unset;
            border-color: #e2e2e2;
            padding-top: 10px;
        }
        .anticon svg {
            color: #797979;
            height: 25px;
            width: 25px;
        }
    }
`;

const PaginationCustom = styled.div`
    .ant-pagination-options {
        display: none;
    }
`;

const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '70px',
    slidesToShow: 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
};

const Products = () => {
    const scrollRef = useRef();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = useMemo(() => {
        return location.search;
    }, [location.search]);

    const cartItemsCount = useSelector(cartItemsCountSelector);

    const [isLoading, setIsLoading] = useState(false);

    const [idCategory, setIdCategory] = useState('');

    const [listCategory, setListCategory] = useState([]);

    const [listCategoryMobile, setListCategoryMobile] = useState([]);

    const userInfo = useSelector((state) => state.user.userInfo);

    const [listProduct, setListProduct] = useState([]);

    const [listHotDeal, setListHotDeal] = useState([]);

    const [listProductForYou, setListProductForYou] = useState([]);

    const [rangePrice, setRangePrice] = useState([0, 100]);

    const [isShowSortCate, setIsShowSortCate] = useState(true);

    const [bannerList, setBannerList] = useState(defaultImages || []);

    const phone_booking = localStorage.getItem('phone_booking');

    const phone = userInfo?.phone || phone_booking;

    const hotDeal = true;

    // const [cateIndexSelected, setCateIndexSelected] = useState(0);

    const [filterOrder, setFilterOrder] = useState({ title: 'Deducted price', value: 'ASC', type: 'deducted_price' });

    const [keySearch, setKeySearch] = useState('');

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 12,
        total_item: 0,
        total_page: 0,
    });

    // Get list Category
    const handleGetListCategory = async () => {
        try {
            let categories = [{ id: '', title: 'All' }];
            const params = {
                fields: '["$all"]',
                order: '[["sort", "ASC"]]',
            };
            const res = await categoryProductAPI.getListCategory(params);
            if (res.code === 200) {
                categories = [...categories, ...res.results.objects.rows];
                // for (let i = 0; i < categories.length; i++) {
                //     const params = {
                //         filter: `{"category_id": "${categories[i].id}" }`,
                //     };
                //     const res = await productAPI.getListProductAPI(params);
                //     categories[i].count = res.results.objects.count;
                // }
            }
            setListCategory(categories);
            const listCateResults = categories.filter((item) => item.id != '');
            setListCategoryMobile(listCateResults);
        } catch (err) {
            console.log(err);
        }
    };
    // Get list Service
    const handleGetListProduct = async (page, cate_id, range, orderBy, search) => {
        try {
            setIsLoading(true);
            let products = [];
            let final = [];
            let filter = `{"$and":[{"deducted_price": {"$between": [${range[0] * 100000}, ${
                range[1] * 100000
            }]}}, {"deducted_price": {"$gt": 0}}, {"type": "PRODUCT"}]}`;
            if (cate_id) {
                filter = `{"$and":[{"category_id":  "${cate_id}"}, {"deducted_price": {"$between": [${
                    range[0] * 100000
                }, ${range[1] * 100000}]}}, {"deducted_price": {"$gt": 0}}, {"type": "PRODUCT"}]}`;
            }

            const params = {
                fields: '["$all", {"category": ["$all"]}]',
                order: orderBy ? `[["${orderBy?.type}", "${orderBy?.value}"]]` : null,
                filter: filter,
                product: search,
                limit: pagination.limit,
                page: page,
            };
            const res = await productAPI.getListProductAPI(params);

            if (res.code === 200) {
                products = res.results.objects.rows;
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / res.pagination.limit),
                });
            }
            if (products?.length) {
                final = [...new Map(products.map((item) => [item['id'], item])).values()];
            }
            setListProduct(final);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
        }
    };
    const handleGetListHotDeal = async () => {
        const filter = {
            $and: [
                {
                    best_sale: true,
                },
                {
                    type: 'PRODUCT',
                },
            ],
        };
        try {
            const params = {
                fields: '["$all"]',
                order: '[["created_at_unix_timestamp", "desc"]]',
                filter: JSON.stringify(filter),
            };
            const res = await productAPI.getHotDealProductAPI(params);

            setListHotDeal(res.results.objects.rows);
        } catch (err) {
            console.log(err);
        }
    };
    const handleGetListProductForYou = async (page) => {
        const filter = {
            $and: [
                {
                    type: 'PRODUCT',
                },
            ],
        };
        try {
            const params = {
                fields: '["$all"]',
                order: '[["deducted_price", "asc"]]',
                filter: JSON.stringify(filter),
                limit: 10,
                page: page,
            };
            const res = await productAPI.getListProductForYouAPI(params);
            setListProductForYou(res.results.objects.rows);
        } catch (err) {
            console.log(err);
        }
    };

    const getHomeInformation = async () => {
        try {
            const res = await homeAPI.currentHomeSetting(phone);
            setBannerList(res.banner_images_mobile);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleGetListCategory();
        handleGetListHotDeal();
        handleGetListProductForYou();
        getHomeInformation();
    }, []);
    const handleChangeRangePrice = (value) => {
        setRangePrice(value);
    };
    const handleChangeRangePriceSubmit = (value) => {
        setRangePrice(value);
        handleGetListProduct(1, idCategory ? idCategory : null, value, filterOrder, keySearch);
    };

    const handleChangeShowSortTable = () => {
        setIsShowSortCate(!isShowSortCate);
    };

    const handleChangeCategory = (id, hotDeal) => {
        navigate({
            pathname: '/san-pham/filter',
            search: `go_search=&hot_deal=${hotDeal}&category_id=${id}`,
        });
    };

    const handleChangeCateIndexSelected = (item, index) => {
        setIdCategory(listCategory[index].id);
        navigate({
            pathname: location.pathname,
            search: `?${item}`,
        });
    };

    const handleSelectFilterOrder = (item) => {
        setFilterOrder(item);
        handleGetListProduct(1, idCategory ? idCategory : null, rangePrice, item, keySearch);
    };

    const handleChangeKeySearch = (e) => {
        const value = e.target.value;
        setKeySearch(value);
    };
    const onSearch = (e) => {
        handleGetListProduct(pagination?.page, idCategory ? idCategory : null, rangePrice, filterOrder, keySearch);
    };

    const handleChangePagination = (page) => {
        scrollRef.current.scrollIntoView();
        setPagination({ ...pagination, page: page });
        handleGetListProductForYou(page);
        handleGetListProduct(page, idCategory ? idCategory : null, rangePrice, filterOrder, keySearch);

        // window.scrollTo(0, 0);
    };

    useEffect(() => {
        const tempIdCategory = location.search.split('?').join('');
        setIdCategory(tempIdCategory);
        handleGetListProduct(1, tempIdCategory, rangePrice, filterOrder, keySearch);
        // eslint-disable-next-line
    }, [queryParams]);

    const menuSort = (
        <Menu
            items={[
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'Price increases gradually',
                                    value: 'ASC',
                                    type: 'deducted_price',
                                })
                            }
                        >
                            Prices gradually increase
                        </p>
                    ),
                    key: '1',
                },
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'Price decreasing',
                                    value: 'DESC',
                                    type: 'deducted_price',
                                })
                            }
                        >
                            Prices gradually decrease
                        </p>
                    ),
                    key: '2',
                },
                // {
                //     label: (
                //         <p
                //             onClick={() =>
                //                 handleSelectFilterOrder({
                // title: 'Ascending order number',
                //                     value: 'ASC',
                //                     type: 'sort',
                //                 })
                //             }
                //         >
                // Number in ascending order
                //         </p>
                //     ),
                //     key: '3',
                // },
                // {
                //     label: (
                //         <p
                //             onClick={() =>
                // handleSelectFilterOrder({ title: 'Descending order', value: 'DESC', type: 'sort' })
                //             }
                //         >
                // Number in descending order
                //         </p>
                //     ),
                //     key: '4',
                // },
            ]}
        />
    );

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangDanhSachSanPham');
        // eslint-disable-next-line
    }, []);

    return (
        <div className="">
            <div className={cx('banner')} ref={scrollRef}>
                <img src={IMAGES.ImageBannerServiceProduct} alt="Banner Spa" />
                {/* <span>Product</span> */}
            </div>

            {/* pc */}
            <div className={cx('service_home_spa')}>
                <Row>
                    <Col xs={24} lg={6}>
                        <div className={cx('left_section')}>
                            <Row className={cx('search')}>
                                <SearchComponent>
                                    <Search
                                        placeholder="Search for products"
                                        value={keySearch}
                                        onChange={handleChangeKeySearch}
                                        onSearch={onSearch}
                                        enterButton
                                    />
                                </SearchComponent>
                            </Row>
                            <Row className={cx('sort_by_price')}>
                                <Col xs={24} className={cx('title')}>
                                    Filter by price
                                </Col>
                                <Col xs={24}>
                                    <SliderAntd
                                        range
                                        defaultValue={rangePrice}
                                        tooltipVisible={false}
                                        onChange={handleChangeRangePrice}
                                        onAfterChange={handleChangeRangePriceSubmit}
                                        step={0.5}
                                    />
                                </Col>
                                <Col xs={24} className={cx('content')}>
                                    Price: {getNumberWithCommas(rangePrice[0] * 100000)} d&nbsp;
                                    <img src={SVGS.IconSub} alt="" />
                                    &nbsp;
                                    {getNumberWithCommas(rangePrice[1] * 100000)} d
                                </Col>
                            </Row>
                            <div className={cx('sort_by_cate')}>
                                <Row className={cx('title')} align="middle" onClick={handleChangeShowSortTable}>
                                    <Col xs={18}>Products</Col>
                                    <Col xs={6}>
                                        <Row justify="end">
                                            <img src={isShowSortCate ? SVGS.IconSub : SVGS.IconPlus} alt="" />
                                        </Row>
                                    </Col>
                                </Row>
                                {listCategory?.length && isShowSortCate
                                    ? listCategory?.map((item, index) => {
                                          return (
                                              <Row
                                                  className={cx(
                                                      item.id === location.search.split('?').join('')
                                                          ? 'item_selected'
                                                          : 'item',
                                                  )}
                                                  onClick={() => handleChangeCateIndexSelected(item.id, index)}
                                                  key={index}
                                              >
                                                  <Col xs={24}>
                                                      <Row>{item.title}</Row>
                                                  </Col>
                                                  {/* <Col xs={6}>
                                                    <Row justify="end">({item.count})</Row>
                                                </Col> */}
                                              </Row>
                                          );
                                      })
                                    : null}
                            </div>
                            <Row className={cx('image')}>
                                <img src={SVGS.ImageSaleProducts} alt="" />
                            </Row>
                        </div>
                    </Col>
                    <Col xs={24} lg={18}>
                        <div className={cx('right_section')}>
                            {isLoading ? (
                                <Row justify="center" className={cx('spin')}>
                                    <Spin />
                                </Row>
                            ) : (
                                <>
                                    <Row className={cx('filter')} align="middle">
                                        <Col sm={10} md={12} xl={14} className={cx('result')}>
                                            <Row>Show all {pagination?.total_item} products</Row>
                                        </Col>
                                        <Col xs={24} sm={14} md={12} xl={10}>
                                            <Row justify="end" style={{ width: '100%' }}>
                                                <Dropdown overlay={menuSort} trigger={['click']}>
                                                    <button
                                                        onClick={(e) => e.preventDefault()}
                                                        className={cx('button')}
                                                    >
                                                        <Row align="middle">
                                                            <Col xs={16}>
                                                                <Row>
                                                                    <span>
                                                                        {filterOrder.value
                                                                            ? filterOrder.title
                                                                            : 'Options'}
                                                                    </span>
                                                                </Row>
                                                            </Col>
                                                            <Col xs={8}>
                                                                <Row justify="end">
                                                                    <DownOutlined />
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </button>
                                                </Dropdown>
                                            </Row>
                                        </Col>
                                    </Row>
                                    {listProduct?.length ? (
                                        <>
                                            <Row className={cx('container_service')}>
                                                {listProduct?.map((item, index) => {
                                                    return (
                                                        <Col xs={24} sm={12} xl={8} key={index}>
                                                            <Row>
                                                                <ItemProduct data={item} />
                                                            </Row>
                                                        </Col>
                                                    );
                                                })}
                                            </Row>
                                            <Row justify="center">
                                                <PaginationCustom>
                                                    <Pagination
                                                        defaultCurrent={1}
                                                        current={pagination?.page}
                                                        total={pagination?.total_item}
                                                        pageSize={pagination?.limit}
                                                        onChange={handleChangePagination}
                                                    />
                                                </PaginationCustom>
                                            </Row>
                                        </>
                                    ) : (
                                        <div className={cx('no_service')}>
                                            <img src={SVGS.IconNoService} alt="" />
                                            <span>No products</span>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            </div>

            {/* mobile */}
            <div className={cx('service_home_spa_mobile')}>
                <div className={cx('header')}>
                    <Row className={cx('header_row')}>
                        <Col className={cx('header_title')}>Product</Col>
                        <Col>
                            <Row>
                                <img
                                    src={SVGS.ImageSearch}
                                    alt="icon search"
                                    className={cx('btn_search')}
                                    onClick={() => {
                                        navigate({
                                            pathname: '/san-pham/filter',
                                            search: `go_search=${true}&hot_deal=&category_id=`,
                                        });
                                    }}
                                />
                                <Badge
                                    count={cartItemsCount}
                                    showZero
                                    overflowCount={99}
                                    className="mt-3"
                                    style={{
                                        backgroundColor: '#FBBC12',
                                        color: '#333',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <img
                                        src={SVGS.IconCart}
                                        alt=""
                                        onClick={() => {
                                            navigate({
                                                pathname: '/gio-hang',
                                            });
                                        }}
                                    />
                                </Badge>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div className={cx('banner_slide')}>
                    <BannerHome bannerList={bannerList} isDesktop={false} />
                </div>

                <div className={cx('tags_section')}>
                    <Swiper
                        slidesPerView={'auto'}
                        slidesPerColumnFill="row"
                        slidesPerColumn={1}
                        spaceBetween={15}
                        freeMode={true}
                        pagination={{
                            clickable: true,
                        }}
                        modules={[FreeMode]}
                        className="mySwiper"
                    >
                        {listCategoryMobile?.length && isShowSortCate
                            ? listCategoryMobile?.map((item, index) => {
                                  return (
                                      <SwiperSlide
                                          key={index}
                                          onClick={() => handleChangeCategory(item.id, '')}
                                          className={cx(
                                              'item',
                                              item.id === location.search.split('?').join('') && 'item_selected',
                                          )}
                                      >
                                          <span key={item?.id}>{item?.title}</span>
                                      </SwiperSlide>
                                  );
                              })
                            : null}
                    </Swiper>
                </div>

                <div>
                    <div className={cx('hot_deal')}>
                        <span className={cx('title')}>Hot deal</span>
                        <div className={cx('more')}>
                            <span
                                onClick={() => {
                                    handleChangeCategory('', hotDeal);
                                    console.log('hotDeal', hotDeal);
                                }}
                            >
                                see more
                            </span>
                            <img src={SVGS.ImageChevronRight} alt="" />
                        </div>
                    </div>
                    <div className={cx('service_slide')}>
                        <Slider {...settings}>
                            {listHotDeal &&
                                listHotDeal.length > 0 &&
                                listHotDeal?.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            <div
                                                className={cx('card_service')}
                                                onClick={() => navigate(`/thong-tin-san-pham/${item?.id}`)}
                                            >
                                                <div className={cx('card_image')}>
                                                    <img
                                                        src={item?.image[0] || IMAGES.ImagePlaceholder}
                                                        alt="img-service"
                                                    />
                                                    {item?.inventory_amount_branch === 0 && (
                                                        <div className={cx('card_inventory_amount')}>
                                                            <span>Sold out</span>
                                                        </div>
                                                    )}

                                                    <div className={cx('card_amount_sale')}>
                                                        <span>{item?.amount_sale} sold</span>
                                                    </div>
                                                </div>
                                                <p className={cx('card_title')}>{item?.title}</p>
                                                <Row align="middle" justify="space-between" className={cx('card_info')}>
                                                    <Row align="bottom" className={cx('card_price')}>
                                                        {getNumberWithCommas(item.price)} d
                                                    </Row>
                                                </Row>
                                            </div>
                                        </div>
                                    );
                                })}
                        </Slider>
                    </div>
                </div>
                <div>
                    <p className={cx('title')}>Exclusively for you</p>
                    {listProductForYou?.length ? (
                        <>
                            <Row className={cx('container_service')}>
                                {listProductForYou?.map((item, index) => {
                                    return (
                                        <Col xs={12} sm={6} xl={8} key={index}>
                                            <Row>
                                                <ItemProduct data={item} />
                                            </Row>
                                        </Col>
                                    );
                                })}
                            </Row>
                            <Row justify="center" style={{ margin: '10px 0' }}>
                                <PaginationCustom>
                                    <Pagination
                                        defaultCurrent={1}
                                        current={pagination?.page}
                                        total={pagination?.total_item}
                                        pageSize={pagination?.limit}
                                        onChange={handleChangePagination}
                                    />
                                </PaginationCustom>
                            </Row>
                        </>
                    ) : (
                        <div className={cx('no_service')}>
                            <img src={SVGS.IconNoService} alt="" />
                            <span>No products</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Products;
